(function() {
  var overlay = document.getElementById('variant-modal-overlay');
  if (!overlay) return;

  var modalImage = document.getElementById('variant-modal-image');
  var modalTitle = document.getElementById('variant-modal-title');
  var modalPrice = document.getElementById('variant-modal-price');
  var modalOptions = document.getElementById('variant-modal-options');
  var modalError = document.getElementById('variant-modal-error');
  var addBtn = document.getElementById('variant-modal-add');
  var closeBtn = overlay.querySelector('.variant-modal__close');

  var currentProduct = null;
  var currentVariants = [];
  var selectedOptions = {};
  var productHandle = '';

  // Override theme's goToProductPage to open modal instead
  // This fires after theme.Cart is initialized
  function patchGoToProductPage() {
    if (typeof theme !== 'undefined' && theme.Cart && theme.Cart.goToProductPage) {
      var originalGoTo = theme.Cart.goToProductPage.bind(theme.Cart);
      theme.Cart.goToProductPage = function($product) {
        var productEl = $product[0] || $product;
        var jsonStr = productEl.getAttribute('data-json-product');

        if (jsonStr) {
          openModal(productEl, jsonStr);
        } else {
          // No variant data available, fall back to navigating to PDP
          originalGoTo($product);
        }
      };
    }
  }

  // Try to patch immediately, and also after assets load
  patchGoToProductPage();
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(patchGoToProductPage, 100);
    setTimeout(patchGoToProductPage, 500);
    setTimeout(patchGoToProductPage, 1500);
  });

  // Also intercept clicks directly in capture phase as a fallback
  // This catches <a> tags with data-button-status="select" before navigation
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-js-product-button-add-to-cart]');
    if (!btn) return;

    var status = btn.getAttribute('data-button-status');
    if (status !== 'select') return;

    var productEl = btn.closest('[data-js-product]');
    if (!productEl) return;

    var jsonStr = productEl.getAttribute('data-json-product');
    if (!jsonStr) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    openModal(productEl, jsonStr);
  }, true);

  var lastFocusedBeforeModal = null;

  function openModal(productEl, jsonStr) {
    lastFocusedBeforeModal = document.activeElement;
    productHandle = productEl.getAttribute('data-product-handle') || '';

    try {
      currentProduct = JSON.parse(jsonStr);
    } catch (err) {
      window.location.href = '/products/' + productHandle;
      return;
    }

    currentVariants = currentProduct.variants || [];
    selectedOptions = {};

    // Get product title from the card (collection cards use h2; the cart upsell's
    // product-featured card uses .product-featured__title h3)
    var titleEl = productEl.querySelector('.product-collection__title h2 a')
      || productEl.querySelector('.product-featured__title a')
      || productEl.querySelector('h3 a')
      || productEl.querySelector('h2 a');
    modalTitle.textContent = titleEl ? titleEl.textContent.trim() : '';

    // Set image (support both collection and product-featured card markup)
    var imgEl = productEl.querySelector('.product-collection__image img')
      || productEl.querySelector('.product-featured__image img')
      || productEl.querySelector('.product-image img');
    if (imgEl) {
      modalImage.src = imgEl.currentSrc || imgEl.src || imgEl.getAttribute('data-src') || '';
      modalImage.alt = modalTitle.textContent;
    }

    buildOptions();
    updatePrice();
    updateAddButton();
    modalError.style.display = 'none';

    overlay.style.display = 'flex';
    requestAnimationFrame(function() {
      overlay.classList.add('is-visible');
      var dialog = overlay.querySelector('.variant-modal');
      if (dialog) dialog.focus();
    });
    document.body.style.overflow = 'hidden';
  }

  // Close modal
  function closeModal() {
    overlay.classList.remove('is-visible');
    setTimeout(function() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      if (lastFocusedBeforeModal && document.body.contains(lastFocusedBeforeModal)) {
        lastFocusedBeforeModal.focus();
      }
    }, 250);
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
  });

  // Build option buttons
  function buildOptions() {
    modalOptions.innerHTML = '';
    var options = currentProduct.options || [];

    options.forEach(function(optionName, optIndex) {
      var values = getOptionValues(optIndex);
      if (values.length === 0) return;

      var group = document.createElement('div');
      group.className = 'variant-modal__option-group';

      var label = document.createElement('label');
      label.textContent = optionName;
      group.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'variant-modal__option-values';

      values.forEach(function(val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'variant-modal__option-btn';
        btn.textContent = val;
        btn.setAttribute('data-option-index', optIndex);
        btn.setAttribute('data-option-value', val);
        btn.addEventListener('click', function() {
          selectOption(optIndex, val);
        });
        valuesWrap.appendChild(btn);
      });

      group.appendChild(valuesWrap);
      modalOptions.appendChild(group);
    });
  }

  // Get unique values for an option position
  function getOptionValues(optIndex) {
    var seen = {};
    var values = [];
    currentVariants.forEach(function(v) {
      var val = getVariantOptionValue(v, optIndex);
      if (val && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });
    return values;
  }

  function getVariantOptionValue(variant, optIndex) {
    return variant['option' + (optIndex + 1)] || null;
  }

  // Select an option
  function selectOption(optIndex, value) {
    selectedOptions[optIndex] = value;

    // Update button states
    var btns = modalOptions.querySelectorAll('[data-option-index="' + optIndex + '"]');
    btns.forEach(function(btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-option-value') === value);
    });

    updateOptionAvailability();
    updatePrice();
    updateAddButton();
    modalError.style.display = 'none';
  }

  // Check which options are available given current selections
  function updateOptionAvailability() {
    var options = currentProduct.options || [];
    options.forEach(function(optionName, optIndex) {
      var btns = modalOptions.querySelectorAll('[data-option-index="' + optIndex + '"]');
      btns.forEach(function(btn) {
        var val = btn.getAttribute('data-option-value');
        var testSelections = Object.assign({}, selectedOptions);
        testSelections[optIndex] = val;

        var hasMatch = currentVariants.some(function(v) {
          return Object.keys(testSelections).every(function(idx) {
            return getVariantOptionValue(v, parseInt(idx)) === testSelections[idx];
          }) && v.available;
        });

        btn.classList.toggle('is-disabled', !hasMatch);
      });
    });
  }

  // Find matched variant
  function getSelectedVariant() {
    var options = currentProduct.options || [];
    if (Object.keys(selectedOptions).length < options.length) return null;

    return currentVariants.find(function(v) {
      return options.every(function(name, idx) {
        return getVariantOptionValue(v, idx) === selectedOptions[idx];
      });
    }) || null;
  }

  // Update price display
  function updatePrice() {
    var variant = getSelectedVariant();
    if (!variant) {
      var prices = currentVariants.filter(function(v) { return v.available; }).map(function(v) { return v.price; });
      if (prices.length === 0) prices = currentVariants.map(function(v) { return v.price; });
      var min = Math.min.apply(null, prices);
      var max = Math.max.apply(null, prices);
      if (min === max) {
        modalPrice.innerHTML = '<strong class="price">' + formatMoney(min) + '</strong>';
      } else {
        modalPrice.innerHTML = '<strong class="price">' + formatMoney(min) + ' - ' + formatMoney(max) + '</strong>';
      }
      return;
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      modalPrice.innerHTML = '<span class="price price--sale">' +
        '<span class="regular-price">' + formatMoney(variant.compare_at_price) + '</span> ' +
        '<strong class="Sale-price">' + formatMoney(variant.price) + '</strong>' +
        '</span>';
    } else {
      modalPrice.innerHTML = '<strong class="price">' + formatMoney(variant.price) + '</strong>';
    }

    if (variant.featured_image && variant.featured_image.src) {
      modalImage.src = variant.featured_image.src;
    }
  }

  // Update add button state
  function updateAddButton() {
    var variant = getSelectedVariant();
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = 'Add to Cart';
      return;
    }
    if (!variant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold Out';
      return;
    }
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Cart';
  }

  // Add to cart button
  addBtn.addEventListener('click', function() {
    var variant = getSelectedVariant();
    if (!variant || !variant.available) {
      modalError.style.display = 'block';
      return;
    }
    addToCart(variant.id);
  });

  function addToCart(variantId) {
    addBtn.classList.add('is-loading');
    addBtn.textContent = 'Adding...';

    var cart = (typeof theme !== 'undefined') ? theme.Cart : null;
    if (!cart) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(res) {
        if (res.ok) {
          closeModal();
          window.location.href = '/cart';
        } else {
          return res.json().then(function(err) { alert(err.description); });
        }
      })
      .finally(function() {
        addBtn.classList.remove('is-loading');
        addBtn.textContent = 'Add to Cart';
      });
      return;
    }

    cart.addItem({ id: variantId, quantity: 1 })
      .then(function(response) {
        if (response.ok) {
          cart.updateCart().then(function() {
            closeModal();
            cart.showPopup();
          });
        } else if (response.status === 422) {
          response.json().then(function(err) {
            alert(err.description);
          });
        }
      })
      .finally(function() {
        addBtn.classList.remove('is-loading');
        addBtn.textContent = 'Add to Cart';
      });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, (typeof theme !== 'undefined' && theme.moneyFormat) || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }
})();
